import $ from "jquery";
import { Module } from "wrapper6";
import NavigationScrollHandler from '../utils/_navigation-scroll';

/*
 -------------------------------
 Class
 -------------------------------
 */

export default class Navigation extends Module {
	ready() {
		this.MAIN_HEADER = document.querySelector('#header');
		this.NAV_TOGGLE = document.querySelector('#navigation-toggle');
		this.OPEN_CLASS = 'navigation--open';
		this.SCROLLED_CLASS = 'navigation--scrolled';
		this.NAVIGATION = document.querySelector('#navigation');

		/**
		 * Handle scroll
		 */
		new NavigationScrollHandler({
			scrollDistance: 40,
			headerElement: this.MAIN_HEADER,
			onEnter: () => this.MAIN_HEADER.classList.add(this.SCROLLED_CLASS),
			onExit: () => this.MAIN_HEADER.classList.remove(this.SCROLLED_CLASS)
		});

		/**
		 * Handle mobile menu
		 */
		this.NAV_TOGGLE.addEventListener('click', event => {
			this.menuIsOpen() ? this.closeMobileMenu(event) : this.openMobileMenu(event);
		});

		this.addDropdownMobile();
	}

	menuIsOpen() {
		return this.MAIN_HEADER.classList.contains(this.OPEN_CLASS);
	}

	openMobileMenu() {
		this.MAIN_HEADER.classList.add(this.OPEN_CLASS);
		this.NAV_TOGGLE.classList.add('open');
		this.NAVIGATION.classList.add('pull_menu_in_out');
	}

	closeMobileMenu() {
		this.MAIN_HEADER.classList.remove(this.OPEN_CLASS);
		this.NAV_TOGGLE.classList.remove('open');
		this.NAVIGATION.classList.remove('pull_menu_in_out');
	}

	addDropdownMobile() {
		// add dropdown icon to menu
		$('.menu-item-has-children').append('<span class="dropdown"> </span>');
		$('.dropdown').click(function() {
			$(this).prev().toggleClass('show-menu');
			$(this).toggleClass('reverse');
		});

		$('li.menu-item-has-children').each(function() {

			var item = $(this);
			var added = true;

			item.on('click', function(e) {
				
				if ($(window).width() > 1000) {
					return;
				}

				var ul = $(this).find('ul.sub-menu');
				var ulHeight = ul.height();			

				if (e.target.tagName !== 'A') {
					
					e.preventDefault();

					if (added ) {

						$(this).addClass('active');
	
						$(this).css({
							marginBottom: ulHeight
						});
	
						var time = 100;
	
						$(this).find('ul').children().each(function(index){
							var obj = $(this);
							setTimeout(function(){
								$(obj).addClass('slide-in');
							}, time);
							time += 50;
						});
	
						added = false;
	
					} else {
	
						var thisObj = $(this);
	
						$(this).removeClass('active');
	
						var time = 100;
	
						$($(this).find('ul li').get().reverse()).each(function() {
							var obj = $(this);
							setTimeout(function(){
								$(obj).removeClass('slide-in');
							}, time);
							time += 50;
						});
	
						setTimeout(function(){
							$(thisObj).css({
								marginBottom: '0px'
							});
						}, time);
	
						added = true;
	
					}
				}
			});

		});
	}
}


// WEBPACK FOOTER //
// ./resources/js/modules/_navigation.js